// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2017, 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.p-DockPanel.p-SplitPanel-child {
  padding: 0px;
}

.p-DockPanel-widget {
  min-width: 100px;
  min-height: 100px;
}

.p-DockPanel-handle[data-orientation="vertical"] {
  min-height: var(--theia-border-width);
  z-index: 3;
}

.p-DockPanel-handle[data-orientation="horizontal"] {
  min-width: var(--theia-border-width);
}

.p-DockPanel-handle[data-orientation="horizontal"]::after {
  min-width: var(--theia-sash-width);
  transform: translateX(0%);
  left: calc(-1 * var(--theia-sash-width) / 2);
}

.p-DockPanel-handle[data-orientation="vertical"]::after {
  min-height: var(--theia-sash-width);
  width: 100%;
  transform: translateY(0%);
  top: calc(-1 * var(--theia-sash-width) / 2);
}

.p-DockPanel-handle:hover::after {
  background-color: var(--theia-sash-hoverBorder);
  transition-delay: var(--theia-sash-hoverDelay);
}

.p-DockPanel-handle:active::after {
  background-color: var(--theia-sash-activeBorder);
  transition-delay: 0s !important;
}

.p-DockPanel-overlay {
  background: var(--theia-editorGroup-dropBackground);
  border: var(--theia-border-width) dashed var(--theia-contrastActiveBorder);
  transition-property: top, left, right, bottom;
  transition-duration: 150ms;
  transition-timing-function: ease;
}

.p-DockPanel-overlay.p-mod-root-top,
.p-DockPanel-overlay.p-mod-root-left,
.p-DockPanel-overlay.p-mod-root-right,
.p-DockPanel-overlay.p-mod-root-bottom,
.p-DockPanel-overlay.p-mod-root-center {
  border-width: 2px;
}

.p-DockPanel-overlay.p-mod-root-bottom {
  background: var(--theia-panel-dropBackground);
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/dockpanel.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,+CAA+C;EAC/C,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;EAChD,+BAA+B;AACjC;;AAEA;EACE,mDAAmD;EACnD,0EAA0E;EAC1E,6CAA6C;EAC7C,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":["/********************************************************************************\n * Copyright (C) 2017, 2018 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.p-DockPanel.p-SplitPanel-child {\n  padding: 0px;\n}\n\n.p-DockPanel-widget {\n  min-width: 100px;\n  min-height: 100px;\n}\n\n.p-DockPanel-handle[data-orientation=\"vertical\"] {\n  min-height: var(--theia-border-width);\n  z-index: 3;\n}\n\n.p-DockPanel-handle[data-orientation=\"horizontal\"] {\n  min-width: var(--theia-border-width);\n}\n\n.p-DockPanel-handle[data-orientation=\"horizontal\"]::after {\n  min-width: var(--theia-sash-width);\n  transform: translateX(0%);\n  left: calc(-1 * var(--theia-sash-width) / 2);\n}\n\n.p-DockPanel-handle[data-orientation=\"vertical\"]::after {\n  min-height: var(--theia-sash-width);\n  width: 100%;\n  transform: translateY(0%);\n  top: calc(-1 * var(--theia-sash-width) / 2);\n}\n\n.p-DockPanel-handle:hover::after {\n  background-color: var(--theia-sash-hoverBorder);\n  transition-delay: var(--theia-sash-hoverDelay);\n}\n\n.p-DockPanel-handle:active::after {\n  background-color: var(--theia-sash-activeBorder);\n  transition-delay: 0s !important;\n}\n\n.p-DockPanel-overlay {\n  background: var(--theia-editorGroup-dropBackground);\n  border: var(--theia-border-width) dashed var(--theia-contrastActiveBorder);\n  transition-property: top, left, right, bottom;\n  transition-duration: 150ms;\n  transition-timing-function: ease;\n}\n\n.p-DockPanel-overlay.p-mod-root-top,\n.p-DockPanel-overlay.p-mod-root-left,\n.p-DockPanel-overlay.p-mod-root-right,\n.p-DockPanel-overlay.p-mod-root-bottom,\n.p-DockPanel-overlay.p-mod-root-center {\n  border-width: 2px;\n}\n\n.p-DockPanel-overlay.p-mod-root-bottom {\n  background: var(--theia-panel-dropBackground);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
